import { useState } from "react";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";

const tokensToString = (tokens, constants) => {
  if (!tokens || tokens.length === 0) return "(tuščia)";
  return tokens
    .map((t) => {
      if (t.type === "CONSTANT") {
        const c = constants?.find((c) => c?.id === t.value);
        return c?.label || t.value;
      }
      if (t.type === "PARAMETER") return t.value;
      if (t.type === "NUMBER") return String(t.value);
      return t.value;
    })
    .join(" ");
};

const FormulaHistoryModal = ({
  isOpen,
  onClose,
  history = [],
  constants = [],
  onRestore,
}) => {
  const [hoveredIdx, setHoveredIdx] = useState(null);

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div style={{ padding: "var(--gap)", minWidth: "min(520px, 90vw)" }}>
        <h2 style={{ margin: 0, marginBottom: "var(--gap)" }}>
          Formulės redagavimo istorija
        </h2>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "var(--spacing-2)",
            maxHeight: "60vh",
            overflowY: "auto",
          }}
        >
          {history.length === 0 && (
            <div style={{ opacity: 0.5, padding: "var(--spacing-2) var(--gap-sm)" }}>
              (tuščia)
            </div>
          )}
          {history.map((entry, idx) => {
            const label = tokensToString(entry, constants);
            const isHovered = hoveredIdx === idx;
            const isCurrent = idx === 0;

            return (
              <div
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "var(--spacing-2) var(--gap-sm)",
                  cursor: isCurrent ? "default" : "pointer",
                }}
                onMouseEnter={() => setHoveredIdx(idx)}
                onMouseLeave={() => setHoveredIdx(null)}
                onClick={() => {
                  if (!isCurrent) {
                    onRestore?.(entry);
                    onClose?.();
                  }
                }}
              >
                <span style={{ color: isHovered && !isCurrent ? "inherit" : "var(--clr-neutral-500)" }}>{label}</span>
                {isHovered && !isCurrent && (
                  <span style={{ color: "var(--clr-sky-700)", whiteSpace: "nowrap", marginLeft: "var(--spacing-2)" }}>
                    ← Atstatyti
                  </span>
                )}
              </div>
            );
          })}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "var(--gap)",
          }}
        >
          <Button onClick={onClose}>Uždaryti</Button>
        </div>
      </div>
    </Modal>
  );
};

export default FormulaHistoryModal;
